import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations, mapState } from 'vuex';
import { randomInt } from '../../../utils/vuex';
import GeoDataMixin from './geoDataMixin';
export default {
  name: 'CoreDtwinGeoDetails',
  mixins: [GeoDataMixin],
  props: {
    twinObject: {
      type: Object,
      required: true
    },
    twinImages: {
      type: Array,
      required: true
    },
    twinCanBeEdited: {
      type: Boolean,
      required: true
    },
    hasFloorTwinReadPermissions: {
      type: Boolean,
      required: true
    },
    floorTwinOverlayData: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    hideFields: {
      // 'polygon', 'mapicon', 'floor', 'floorplan'
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      fullScreenMap: false,
      overlayDialog: false,
      overlayInfo: null,
      overlayUploadItem: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions', 'UiTheme'])), {}, {
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    }
  }),
  watch: {},
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    overlayImageSelected: function overlayImageSelected() {
      if (!this.twinObject.data.indoor.neLat && !this.twinObject.data.indoor.swLat) {
        this.twinObject.data.indoor.neLat = this.twinObject.coordinates.coordinates[1] + 0.0001;
        this.twinObject.data.indoor.neLon = this.twinObject.coordinates.coordinates[0] + 0.0001;
        this.twinObject.data.indoor.swLat = this.twinObject.coordinates.coordinates[1] - 0.0001;
        this.twinObject.data.indoor.swLon = this.twinObject.coordinates.coordinates[0] - 0.0001;
      }
    },
    overlayImageUploaded: function overlayImageUploaded(attachment) {
      this.overlayDialog = false;
      var attachmentItem = {
        id: attachment.fileId,
        name: attachment.item.name,
        size: attachment.item.size
      };
      this.twinObject.data.attachments = (this.twinObject.data.attachments || []).concat([attachmentItem]);
      this.twinObject.data.indoor.overlayImageId = attachmentItem.id;
      this.twinObject.data.indoor.neLat = this.overlayInfo.ne.lat;
      this.twinObject.data.indoor.neLon = this.overlayInfo.ne.lon;
      this.twinObject.data.indoor.swLat = this.overlayInfo.sw.lat;
      this.twinObject.data.indoor.swLon = this.overlayInfo.sw.lon;
    },
    handleOverlayImage: function handleOverlayImage(processedInfo) {
      this.overlayInfo = processedInfo;

      var dataURLtoFile = function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(',');
        var mime = arr[0].match(/:(.*?);/)[1];
        var bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, {
          type: mime
        });
      };

      var attachmentItem = dataURLtoFile(processedInfo.image, processedInfo.imageFileName);
      this.overlayUploadItem = {
        id: "".concat(Date.now()).concat(randomInt(2000)),
        name: attachmentItem.name,
        size: attachmentItem.size,
        file: attachmentItem
      };
    }
  })
};